export default __webpack_public_path__ + "static/media/home7.cf2d23d6.jpg";